"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const GtmDataLayer_1 = __importDefault(require("@react/common/GtmDataLayer/GtmDataLayer"));
const CarOfferData_1 = __importDefault(require("@react/common/GtmDataLayer/FacebookPixel/CarOfferData"));
const FacebookPixelSearchData_1 = __importDefault(require("@react/common/GtmDataLayer/FacebookPixel/FacebookPixelSearchData"));
const PriceOfferData_1 = __importDefault(require("@react/common/GtmDataLayer/FacebookPixel/PriceOfferData"));
function pushFacebookPixelSearchSubscriptionOffers(filteredListingOffers) {
    const facebookPixelSearchData = [];
    filteredListingOffers.forEach((carOffer) => {
        carOffer.simpleOfferList.simpleOffers.forEach((simpleOffer) => {
            const carOfferData = new CarOfferData_1.default(carOffer.makeName, carOffer.modelName);
            const firstPriceOffer = simpleOffer.priceOfferList.getFlexiblePriceOffers().getCheapestPriceOffer();
            if (firstPriceOffer === null) {
                return;
            }
            const priceOfferData = new PriceOfferData_1.default(firstPriceOffer.amount.withoutVat, simpleOffer.id);
            facebookPixelSearchData.push(new FacebookPixelSearchData_1.default(carOfferData, simpleOffer.facebookAutomotiveData, priceOfferData));
        });
    });
    (0, GtmDataLayer_1.default)({
        event: 'subscription-filtered-listing-loaded',
        subscriptionOffers: facebookPixelSearchData,
    });
}
exports.default = pushFacebookPixelSearchSubscriptionOffers;
